import {
  allowedOpensConfig,
  opens2fa,
  opensConfig,
  opensLogin, // Commented out for testing
  opensStatus,
} from '@/constants/endpoints';

import { APIClient } from '@/lib/ApiClient';

const apiClient = new APIClient();

export function loginUserForOpens(username, password) {
  return apiClient.create(
    opensLogin,
    {
      username,
      password,
    },
    true
  );
}

export function manage2faSetupForOpens(
  twoFactorIdentifier,
  verificationMethod,
  code
) {
  const data = {
    verification_method: verificationMethod,
    two_factor_identifier: twoFactorIdentifier,
    code: code,
  };

  return apiClient.create(opens2fa, data, true);
}

export function getOpensStatus() {
  return apiClient.get(opensStatus, null, true);
}

export function getAllowedOpensConfig() {
  return apiClient.get(allowedOpensConfig, null, true);
}
export function getOpensConfig() {
  return apiClient.get(opensConfig, null, true);
}

export function saveOpensConfig(config) {
  return apiClient.create(opensConfig, config, true);
}
